import { Application } from "types";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserPopover } from "@/components/Popover/User";
import { Link, useNavigate, useParams } from "react-router-dom";
import ErrorBoundary from "@/ErrorBoundary";

export default function ApplicationBodyItem({ item, isMeApplications }: { item: Application, isMeApplications?: boolean }) {
    const { teamId, channelId } = useParams();
    const navigate = useNavigate();
    return (
        <>
            <ErrorBoundary>
                <tr key={item.id} className="hover:bg-brand-default transition-all cursor-pointer" onClick={() => {
                    if (!isMeApplications) {
                        navigate(`/teams/${teamId}/channels/${channelId}/applications/${item.id}`);
                    }
                }}>
                    <td className="py-3 px-4 flex items-center text-white">
                        <UserPopover user={item.submittedBy}>
                            <div className="flex items-center gap-2 cursor-pointer">
                                <Avatar>
                                    <AvatarImage src={item.submittedBy.profilePicture} />
                                    <AvatarFallback className="bg-brand-profile">{item.submittedBy.username[0]}</AvatarFallback>
                                </Avatar>
                                <span className="ml-2">{item.submittedBy.username}</span>
                            </div>
                        </UserPopover>
                    </td>
                    
                    <td className={`py-3 px-4 text-gray-300 ${item.status === "pending" ? "text-yellow-500" : item.status === "accepted" ? "text-green-500" : "text-red-500"}`}>
                        {item.status === "pending" ? "Pending" : item.status === "accepted" ? "Approved" : "Rejected"}
                    </td>
                    <td className="py-3 px-4 text-gray-300">{new Date(item.createdAt).toLocaleString()}</td>
                    <td className="py-3 px-4">
                        {isMeApplications && item.team ? (
                            <div className="flex items-center gap-2 cursor-pointer">
                                <Avatar>
                                    <AvatarImage src={item.team.profilePicture} />
                                    <AvatarFallback className="bg-brand-profile">{item.team.name[0]}</AvatarFallback>
                                </Avatar>
                                <span className="ml-2">{item.team.name}</span>
                            </div>
                        ) : (

                            <Link to={`/teams/${teamId}/channels/${channelId}/applications/${item.id}`}
                                className="border-brand-green border hover:bg-brand-green px-3 sm:px-4 py-2 rounded-lg text-white font-semibold text-xs sm:text-sm">
                                View
                            </Link>
                        )}
                    </td>
                </tr>
            </ErrorBoundary>
        </>
    );
}
